/**
 * projects.js — API client for project save/load
 * Uses ltbb-ba-token from localStorage (set by AuthModal)
 */

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const TOKEN_KEY = 'ltbb-ba-token';

function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}

function authHeaders() {
  const token = getToken();
  if (!token) throw new Error('AUTH_REQUIRED');
  return { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` };
}

/** List user's projects */
export async function listProjects() {
  const res = await fetch(`${BACKEND_URL}/api/v1/projects`, { headers: authHeaders() });
  if (res.status === 401 || res.status === 403) throw new Error('AUTH_REQUIRED');
  if (!res.ok) throw new Error(`List projects failed: ${res.status}`);
  return res.json();
}

/** Create a new project */
export async function createProject(data) {
  const res = await fetch(`${BACKEND_URL}/api/v1/projects`, {
    method: 'POST',
    headers: authHeaders(),
    body: JSON.stringify(data),
  });
  if (res.status === 401 || res.status === 403) throw new Error('AUTH_REQUIRED');
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.detail || `Create project failed: ${res.status}`);
  }
  return res.json();
}

/** Save/update a project */
export async function saveProject(projectId, data) {
  const res = await fetch(`${BACKEND_URL}/api/v1/projects/${projectId}`, {
    method: 'PUT',
    headers: authHeaders(),
    body: JSON.stringify(data),
  });
  if (res.status === 401 || res.status === 403) throw new Error('AUTH_REQUIRED');
  if (!res.ok) throw new Error(`Save project failed: ${res.status}`);
  return res.json();
}

/** Load a project */
export async function loadProject(projectId) {
  const res = await fetch(`${BACKEND_URL}/api/v1/projects/${projectId}`, {
    headers: authHeaders(),
  });
  if (res.status === 401 || res.status === 403) throw new Error('AUTH_REQUIRED');
  if (!res.ok) throw new Error(`Load project failed: ${res.status}`);
  return res.json();
}

/** Delete a project */
export async function deleteProject(projectId) {
  const res = await fetch(`${BACKEND_URL}/api/v1/projects/${projectId}`, {
    method: 'DELETE',
    headers: authHeaders(),
  });
  if (res.status === 401 || res.status === 403) throw new Error('AUTH_REQUIRED');
  if (!res.ok) throw new Error(`Delete project failed: ${res.status}`);
  return res.json();
}
